import { Preferences } from '@capacitor/preferences';

/** Legacy Capacitor Preferences keys cleared after successful v2 session migration. */
export const LEGACY_PREFERENCE_KEYS = [
  'userId',
  'customerId',
  'NID',
  'cartData',
  'couponData',
  'pilotCart',
  'pilotSelectedStore',
];

/** Remove legacy local prefs so stale auth/cart data cannot bleed into the legacy UI. */
export async function clearLegacyLocalCache() {
  await Promise.all(
    LEGACY_PREFERENCE_KEYS.map((key) => Preferences.remove({ key })),
  );
}
